import React from 'react';
import { View, Svg, Path } from '@react-pdf/renderer';
import { styles } from '../../../utils/styles';

var _ref = /*#__PURE__*/React.createElement(Path, {
  fill: "#000",
  d: "M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"
});

export const PrnPDF = ({
  isPrn
}) => /*#__PURE__*/React.createElement(View, {
  style: styles.width10
}, isPrn && /*#__PURE__*/React.createElement(Svg, {
  style: {
    height: '.4cm',
    width: '.4cm'
  },
  viewBox: "0 0 448 512"
}, _ref));